import { IsiPlAssociatedViewManager } from "../../PresentationLogic/IsiPlAssociatedViewManager";
import { IsiIWSAssociatedViewContext } from "./IsiIwsAssociatedViewContext";

/**
 * Gestionnaire de liaison d'une donnée associée et son formulaire.
 */
export class IsiAssociatedViewXmlJoinManager {

    /// Liste pour chaque AssContextId la liste des controles de liaison et leurs valeurs.
    private _linkJoinContexts: Map<string, Map<string, string>>

    /// gestionnaire de présentation des données associées
    private _pl: IsiPlAssociatedViewManager;

    /**
     * Constructeur
     */
    constructor() {
        this._linkJoinContexts = new Map<string, Map<string, string>>();
        this._pl = new IsiPlAssociatedViewManager();
    }
    /**
     * retourne la collection des controles mis à jour pour la liaison de la da.
     * @param associatedViewContext
     * @returns
     */
    public getUpdatedJoinCtrls(associatedViewContext: IsiIWSAssociatedViewContext): { [key: string]: string; } {
        const ctrlVals = {};
        let controlsValues: Map<string, string>;
        controlsValues = new Map<string, string>();
        if (associatedViewContext.associatedViewState?.linkContext.joinLinkedCtrls) {
            for (const ctrlId of associatedViewContext.associatedViewState.linkContext.joinLinkedCtrls) {
                if (!ctrlId.startsWith("$") && iwsAllCtrls.getCtrl(ctrlId)) {
                    ctrlVals[ctrlId] = iwsAllCtrls.getCtrl(ctrlId).value();
                }
            }
        }

        return ctrlVals;
    }

    /**
     * Détermine si une donnée associée doit mettre à jour son lien maitre détail et le met à jour si nécessaire.
     * @param associatedViewContext
     */
    public async updateCtrlJoin(associatedViewContext: IsiIWSAssociatedViewContext) {
        let controlsValues: Map<string, string>;
        if (associatedViewContext.associatedViewState.linkContext.joinLinkedCtrls) {
            if (!this._linkJoinContexts.has(associatedViewContext.id)) {
                controlsValues = this._initAssContextCtrlJoin(associatedViewContext);
                await this._pl.updateCtrlJoin(associatedViewContext.id, controlsValues);
            } else {
                controlsValues = this._linkJoinContexts.get(associatedViewContext.id);
                if (this._isUpdateNeeded(associatedViewContext)) {
                    await this._pl.updateCtrlJoin(associatedViewContext.id, controlsValues);
                }
            }
        }

    }
    /**
    * Initialise l'état des contrôles de la page pour l'évaluation du lien maitre détail.
    * @param associatedViewContext
    * @returns
    */
    private _isUpdateNeeded(associatedViewContext: IsiIWSAssociatedViewContext): boolean {
        let updateNeeded = false;
        let ctrlValue: string;
        let controlsValues = this._linkJoinContexts.get(associatedViewContext.id);
        for (const ctrlId of associatedViewContext.associatedViewState.linkContext.joinLinkedCtrls) {
            if (!ctrlId.startsWith("$") && iwsAllCtrls.getCtrl(ctrlId)) {
                ctrlValue = iwsAllCtrls.getCtrl(ctrlId).value();
                if (!controlsValues.has(ctrlId)) {
                    uiCore.log(`Il manque le controle ${ctrlId} pour l'évaluation du lien de la donnée associée ${associatedViewContext.id}.`)
                } else {
                    if (ctrlValue !== controlsValues.get(ctrlId)) {
                        controlsValues.set(ctrlId, ctrlValue);
                        updateNeeded = true;
                    }
                }
            }
        }
        return updateNeeded;
    }

    /**
     * Initialise l'état des contrôles de la page pour l'évaluation du lien maitre détail.
     * @param associatedViewContext
     * @returns
     */
    private _initAssContextCtrlJoin(associatedViewContext: IsiIWSAssociatedViewContext): Map<string, string> {
        let controlsValues: Map<string, string>;
        controlsValues = new Map<string, string>();
        for (const ctrlId of associatedViewContext.associatedViewState.linkContext.joinLinkedCtrls) {
            if (!ctrlId.startsWith("$") && iwsAllCtrls.getCtrl(ctrlId)) {
                controlsValues.set(ctrlId, iwsAllCtrls.getCtrl(ctrlId).value());
            }
        }
        this._linkJoinContexts.set(associatedViewContext.id, controlsValues);
        return controlsValues;
    }


}